import CONFIG from "../temp/config";
import { ID_TYPES } from './constants'
import {NassauLog} from "./myga-utils";

export let PROCESSING_STATUS = Object.freeze({
    SUCCESS : "SUCCESS",
    DETECTION_FAILED : "DETECTION_FAILED",
    IMAGE_PREPROCESSING_FAILED : "IMAGE_PREPROCESSING_FAILED",
    STABILITY_TEST_FAILED : "STABILITY_TEST_FAILED",
    SCANNING_WRONG_SIDE : "SCANNING_WRONG_SIDE",
    FIELD_IDENTIFICATION_FAILED : "FIELD_IDENTIFICATION_FAILED",
    MANDATORY_FIELD_MISSING : "MANDATORY_FIELD_MISSING",
    INVALID_CHARACTERS_FOUND : "INVALID_CHARACTERS_FOUND",
    IMAGE_RETURN_FAILED : "IMAGE_RETURN_FAILED",
    BARCODE_RECOGNITION_FAILED : "BARCODE_RECOGNITION_FAILED",
    MRZ_PARSING_FAILED : "MRZ_PARSING_FAILED",
    CLASS_FILTERED : "CLASS_FILTERED",
    UNSUPPORTED_CLASS : "UNSUPPORTED_CLASS",
    UNSUPPORTED_BY_LICENSE : "UNSUPPORTED_BY_LICENSE",
    AWAITING_OTHER_SIDE : "AWAITING_OTHER_SIDE",
});

export let RECOGNITION_STATUS = Object.freeze({
    EMPTY : "EMPTY",
    UNCERTAIN : "UNCERTAIN",
    VALID : "VALID",
    STAGE_VALID : "STAGE_VALID",
});

export let RECOGNITION_MODE = Object.freeze({
    NONE : "NONE",
    MRZ_ID : "MRZ_ID",
    MRZ_VISA : "MRZ_VISA",
    MRZ_PASSPORT : "MRZ_PASSPORT",
    PHOTO_ID : "PHOTO_ID",
    FULL_RECOGNITION : "FULL_RECOGNITION",
});

export let REGIONS = Object.freeze({
    REGION_NONE: "REGION_NONE",
    REGION_ALABAMA: "REGION_ALABAMA",
    REGION_ALASKA: "REGION_ALASKA",
    REGION_ARIZONA: "REGION_ARIZONA",
    REGION_ARKANSAS: "REGION_ARKANSAS",
    REGION_CALIFORNIA: "REGION_CALIFORNIA",
    REGION_COLORADO: "REGION_COLORADO",
    REGION_CONNECTICUT: "REGION_CONNECTICUT",
    REGION_DELAWARE: "REGION_DELAWARE",
    REGION_DISTRICT_OF_COLUMBIA: "REGION_DISTRICT_OF_COLUMBIA",
    REGION_FLORIDA: "REGION_FLORIDA",
    REGION_GEORGIA: "REGION_GEORGIA",
    REGION_HAWAII: "REGION_HAWAII",
    REGION_IDAHO: "REGION_IDAHO",
    REGION_ILLINOIS: "REGION_ILLINOIS",
    REGION_INDIANA: "REGION_INDIANA",
    REGION_IOWA: "REGION_IOWA",
    REGION_KANSAS: "REGION_KANSAS",
    REGION_KENTUCKY: "REGION_KENTUCKY",
    REGION_LOUISIANA: "REGION_LOUISIANA",
    REGION_MAINE: "REGION_MAINE",
    REGION_MARYLAND: "REGION_MARYLAND",
    REGION_MASSACHUSETTS: "REGION_MASSACHUSETTS",
    REGION_MICHIGAN: "REGION_MICHIGAN",
    REGION_MINNESOTA: "REGION_MINNESOTA",
    REGION_MISSISSIPPI: "REGION_MISSISSIPPI",
    REGION_MISSOURI: "REGION_MISSOURI",
    REGION_MONTANA: "REGION_MONTANA",
    REGION_NEBRASKA: "REGION_NEBRASKA",
    REGION_NEVADA: "REGION_NEVADA",
    REGION_NEW_HAMPSHIRE: "REGION_NEW_HAMPSHIRE",
    REGION_NEW_JERSEY: "REGION_NEW_JERSEY",
    REGION_NEW_MEXICO: "REGION_NEW_MEXICO",
    REGION_NEW_YORK: "REGION_NEW_YORK",
    REGION_NORTH_CAROLINA: "REGION_NORTH_CAROLINA",
    REGION_NORTH_DAKOTA: "REGION_NORTH_DAKOTA",
    REGION_OHIO: "REGION_OHIO",
    REGION_OKLAHOMA: "REGION_OKLAHOMA",
    REGION_OREGON: "REGION_OREGON",
    REGION_PENNSYLVANIA: "REGION_PENNSYLVANIA",
    REGION_RHODE_ISLAND: "REGION_RHODE_ISLAND",
    REGION_SOUTH_CAROLINA: "REGION_SOUTH_CAROLINA",
    REGION_SOUTH_DAKOTA: "REGION_SOUTH_DAKOTA",
    REGION_TENNESSEE: "REGION_TENNESSEE",
    REGION_TEXAS: "REGION_TEXAS",
    REGION_UTAH: "REGION_UTAH",
    REGION_VERMONT: "REGION_VERMONT",
    REGION_VIRGINIA: "REGION_VIRGINIA",
    REGION_WASHINGTON: "REGION_WASHINGTON",
    REGION_WEST_VIRGINIA: "REGION_WEST_VIRGINIA",
    REGION_WISCONSIN: "REGION_WISCONSIN",
    REGION_WYOMING: "REGION_WYOMING",
});

export let US_STATES = [
    { name: 'ALABAMA', abbreviation: 'AL'},
    { name: 'ALASKA', abbreviation: 'AK'},
    { name: 'ARIZONA', abbreviation: 'AZ'},
    { name: 'ARKANSAS', abbreviation: 'AR'},
    { name: 'CALIFORNIA', abbreviation: 'CA'},
    { name: 'COLORADO', abbreviation: 'CO'},
    { name: 'CONNECTICUT', abbreviation: 'CT'},
    { name: 'DELAWARE', abbreviation: 'DE'},
    { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC'},
    { name: 'FLORIDA', abbreviation: 'FL'},
    { name: 'GEORGIA', abbreviation: 'GA'},
    { name: 'HAWAII', abbreviation: 'HI'},
    { name: 'IDAHO', abbreviation: 'ID'},
    { name: 'ILLINOIS', abbreviation: 'IL'},
    { name: 'INDIANA', abbreviation: 'IN'},
    { name: 'IOWA', abbreviation: 'IA'},
    { name: 'KANSAS', abbreviation: 'KS'},
    { name: 'KENTUCKY', abbreviation: 'KY'},
    { name: 'LOUISIANA', abbreviation: 'LA'},
    { name: 'MAINE', abbreviation: 'ME'},
    { name: 'MARYLAND', abbreviation: 'MD'},
    { name: 'MASSACHUSETTS', abbreviation: 'MA'},
    { name: 'MICHIGAN', abbreviation: 'MI'},
    { name: 'MINNESOTA', abbreviation: 'MN'},
    { name: 'MISSISSIPPI', abbreviation: 'MS'},
    { name: 'MISSOURI', abbreviation: 'MO'},
    { name: 'MONTANA', abbreviation: 'MT'},
    { name: 'NEBRASKA', abbreviation: 'NE'},
    { name: 'NEVADA', abbreviation: 'NV'},
    { name: 'NEW HAMPSHIRE', abbreviation: 'NH'},
    { name: 'NEW JERSEY', abbreviation: 'NJ'},
    { name: 'NEW MEXICO', abbreviation: 'NM'},
    { name: 'NEW YORK', abbreviation: 'NY'},
    { name: 'NORTH CAROLINA', abbreviation: 'NC'},
    { name: 'NORTH DAKOTA', abbreviation: 'ND'},
    { name: 'OHIO', abbreviation: 'OH'},
    { name: 'OKLAHOMA', abbreviation: 'OK'},
    { name: 'OREGON', abbreviation: 'OR'},
    { name: 'PENNSYLVANIA', abbreviation: 'PA'},
    { name: 'PUERTO RICO', abbreviation: 'PR'},
    { name: 'RHODE ISLAND', abbreviation: 'RI'},
    { name: 'SOUTH CAROLINA', abbreviation: 'SC'},
    { name: 'SOUTH DAKOTA', abbreviation: 'SD'},
    { name: 'TENNESSEE', abbreviation: 'TN'},
    { name: 'TEXAS', abbreviation: 'TX'},
    { name: 'UTAH', abbreviation: 'UT'},
    { name: 'VERMONT', abbreviation: 'VT'},
    { name: 'VIRGINIA', abbreviation: 'VA'},
    { name: 'WASHINGTON', abbreviation: 'WA'},
    { name: 'WEST VIRGINIA', abbreviation: 'WV'},
    { name: 'WISCONSIN', abbreviation: 'WI'},
    { name: 'WYOMING', abbreviation: 'WY' }
];

export let getStateExportForRegion = (region) => {

    let cleanedRegion = region.replace("REGION_","").replace("_"," ");

    //If no match, return an empty string.
    let matchedStates = US_STATES.filter( (state) => {
        return state.name === cleanedRegion;
    }  );

    if (matchedStates.length === 0) {
        return { name: '', abbreviation: '' }
    } else {
        return matchedStates[0];
    }

};

export let getDisplayForIdType = (theType) => {
    switch (theType) {
        case 'TYPE_DL':
            return "Driver's License";
        case 'TYPE_PASSPORT':
            return "Passport";
        case 'TYPE_ID':
            return "Identification";
        default:
            NassauLog("Unknown IdType: "+theType);
            return 'Other';
    }
};

export let getExportValueForIdType = (theType) => {
    switch (theType) {
        case 'TYPE_DL':
            return ID_TYPES.DriversLicenseOrID;
        case 'TYPE_PASSPORT':
            return ID_TYPES.Passport;
        case 'TYPE_ID':
            return ID_TYPES.DriversLicenseOrID;
        default:
            NassauLog("Unknown IdType: "+theType);
            return 'Other';
    }
};

export let getDisplayForRecognitionStatus = (status) => {
    switch (status) {
        case RECOGNITION_STATUS.VALID:
            return "VALID";
        case RECOGNITION_STATUS.UNCERTAIN:
            return "UNCERTAIN";
        default:
            NassauLog("Unknown Recognition Status: " + status);
            return 'OTHER';
    }
};



